import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageHero"] */ "/vercel/path0/src/components/ui/kit.tsx");
